/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shopping_Range_ResetInputs */

const en_shopping_range_reset = /** @type {(inputs: Shopping_Range_ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Default (until the next shopping day)`)
};

const de_shopping_range_reset = /** @type {(inputs: Shopping_Range_ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standard (bis zum nächsten Einkaufstag)`)
};

/**
* | output |
* | --- |
* | "Default (until the next shopping day)" |
*
* @param {Shopping_Range_ResetInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const shopping_range_reset = /** @type {((inputs?: Shopping_Range_ResetInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shopping_Range_ResetInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_shopping_range_reset(inputs)
	return en_shopping_range_reset(inputs)
});